import ResourceCollectionsList from "./ResourceCollectionsList";
import ResourcesList from "./ResourcesList";

export default {
  ResourceCollectionsList,
  ResourcesList
};
